const IMAGE_MIME_PREFIX = 'image/'

const IMAGE_EXTENSIONS = new Set([
  'jpg',
  'jpeg',
  'png',
  'gif',
  'webp',
  'bmp',
  'heic',
  'heif',
  'avif',
])

export const isCrmIntegrationPendingImageFile = (file: File): boolean => {
  if (file.type.startsWith(IMAGE_MIME_PREFIX)) {
    return true
  }

  const extension = file.name.split('.').pop()?.toLowerCase()
  return extension != null && IMAGE_EXTENSIONS.has(extension)
}

/** Локальное превью до ответа API (`blob:` URL). */
export const createCrmIntegrationPendingImagePreviewUrl = (
  file: File,
): string | undefined => {
  if (!isCrmIntegrationPendingImageFile(file)) {
    return undefined
  }

  return URL.createObjectURL(file)
}

export const createCrmIntegrationPendingVideoPreviewUrl = (
  file: File,
): string | undefined => {
  if (!file.type.startsWith('video/')) {
    const extension = file.name.split('.').pop()?.toLowerCase()
    const videoExtensions = new Set(['mp4', 'mov', 'mkv', 'webm', 'avi'])
    if (!extension || !videoExtensions.has(extension)) {
      return undefined
    }
  }

  return URL.createObjectURL(file)
}

export const revokeCrmIntegrationPendingPreviewUrl = (
  previewUrl: string | undefined,
): void => {
  if (!previewUrl || !previewUrl.startsWith('blob:')) {
    return
  }

  URL.revokeObjectURL(previewUrl)
}
